import { Component, Suspense } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import AppLoadingIndicator from './appLoadingIndicator'

class RouteErrorBoundary extends Component {
  state = { failed: false, resetKey: this.props.resetKey }

  static getDerivedStateFromProps({ resetKey }, state) {
    if (resetKey !== state.resetKey) return { failed: false, resetKey }
    return null
  }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  render() {
    return this.state.failed ? this.props.fallback : this.props.children
  }
}

export default function RouteLoadingBoundary({ children }) {
  const { pathname } = useLocation()
  const { t } = useTranslation('commonTranslation')

  return (
    <RouteErrorBoundary
      resetKey={pathname}
      fallback={
        <div role="alert">
          <p>{t('routeLoading.failed')}</p>
          <button type="button" onClick={() => window.location.reload()}>
            {t('routeLoading.reload')}
          </button>
        </div>
      }
    >
      <Suspense fallback={<AppLoadingIndicator />}>
        {children}
      </Suspense>
    </RouteErrorBoundary>
  )
}
